'use strict';
var AirportSelectorModel = require('../models/airport_selector.model');

const getErrorClass = () => {
    return Odigeo.AB.isCssVariationHeaderDesktop ? 'invalid' : 'error';
};
const getTemplate = () => {
    return Odigeo.AB.isCssVariationHeaderDesktop ? '#airport_selector_template_cobalt_variation' : '#airport_selector_template';
};
const getZeroResultsTemplate = () => {
    return Odigeo.AB.isCssVariationHeaderDesktop ? '#airport_autocomplete_zero_results_cobalt_variation' : '#airport_autocomplete_zero_results';
};

module.exports = Odigeo.View.extend({
    initialize: function(options) {
        this.model = new AirportSelectorModel({}, {departureOrArrival: options.departureOrArrival,
            showNearestLocations: options.showNearestLocations});
        this.parent = options.parent;
        this.template = options.template || Odigeo._.template(this.parent.$el.find(getTemplate()).html(),
            Odigeo.Utils.getTmplSettings({variable: null}));

        const $autoCompleteTemplate = '#airport_autocomplete_template' + (Odigeo.AB.isCssVariationHeaderDesktop ? '_cobalt' : '');
        this.autocomplete = new Odigeo.UIElements.Autocomplete(
            this.$el,
            this.model,
            {
                tmpl: options.templateAutoComplete || Odigeo._.template(
                    this.parent.$el.find($autoCompleteTemplate).html(), Odigeo.Utils.getTmplSettings({variable: null})),
                tmplZero: options.templateAutoCompleteZero || Odigeo._.template(
                    this.parent.$el.find(getZeroResultsTemplate()).html(), Odigeo.Utils.getTmplSettings({variable: null})),
                zeroMsg: options.errorMessages.zeroResults,
                subTree: Odigeo.AB.isCssVariationHeaderDesktop ? 'relatedLocations' : undefined,
            }
        );
        this.placeholder = options.placeholder;
        this.tabIndex = options.tabIndex;
        this.departureOrArrival = options.departureOrArrival;
        this.render();
        this.setCallbacks(options.callbacks);
        this.$input = this.$el.find(this.selectors.input);
        this.$airportContainer = this.$input.parent();
        this.listenTo(this.model, 'change:selectedLocation', this.setInputValue);
        this.listenTo(this.model, 'change:selectedLocation', this.updateSearchSegments);
        this.parent.model.listenSearchModelProperty('type', Odigeo._.bind(this.updateInputWidth, this));
    },

    selectors: {
        input: '.airport_selector_input',
    },

    events: {
        'focus .airport_selector_input': 'onInputFocus',
        'input .airport_selector_input': 'onInputChange',
        'blur .airport_selector_input': 'onInputBlur',
        'mousedown .autocomplete_item': 'onSelectSuggestion',
        'keyup .airport_selector_input': 'onKeyPress',
    },

    skipInputBlur: false,

    setCallbacks: function(callbacks) {
        this.onFocusCb = callbacks.onFocus;
    },

    render: function() {
        this.$el.html(this.template({
            placeholder: this.placeholder,
            tabIndex: this.tabIndex,
            isOneWay: this.parent.model.isOneWay(),
            departureOrArrival: this.departureOrArrival}));
        return this;
    },

    updateInputWidth: function() {
        this.$el.toggleClass('one-way', this.parent.model.isOneWay());
    },

    setInputValue: function() {
        var selectedLocation = this.model.get('selectedLocation') || {};
        var searchWord = selectedLocation.name || '';
        this.$input.val(searchWord);
    },

    updateSearchSegments: function() {
        this.parent.model.trigger('update');
    },

    onInputFocus: function() {
        var searchWord = this.$input.val().trim();
        this.$input.select();
        this.model.set({'searchWord': searchWord});
        this.model.trigger('autocomplete');
        if (this.onFocusCb) {
            this.onFocusCb(this);
        }
    },

    showError: function() {
        this.$airportContainer.addClass(getErrorClass());
    },

    removeError: function() {
        this.$airportContainer.removeClass(getErrorClass());
    },

    onInputChange: function(event) {
        this.model.set({'searchWord': event.currentTarget.value.trim()});
    },

    onInputBlur: function() {
        Odigeo._.delay(Odigeo._.bind(function() {
            var autocompleteSuggestions = this.model.get('autocompleteSuggestions');
            var activeSuggestion = this.$el.find('.autocomplete_item.hover');
            var searchWord = this.model.get('searchWord');
            var selectedLocation = this.model.get('selectedLocation');
            var suggestionIndex = activeSuggestion.data('index');
            var suggestionRelatedIndex = activeSuggestion.data('related-index');
            if (!this.skipInputBlur) {
                this.$el.removeClass('open empty');
                if (searchWord.length >= 3 && !Odigeo._.isEmpty(autocompleteSuggestions)) {
                    selectedLocation = autocompleteSuggestions[suggestionIndex];
                    if (suggestionRelatedIndex) {
                        selectedLocation = selectedLocation.relatedLocations[suggestionRelatedIndex];
                    }
                    this.model.set('selectedLocation', selectedLocation);
                }
                this.setInputValue();
            } else {
                this.skipInputBlur = false;
            }
        }, this), 100);
    },

    onSelectSuggestion: function(event) {
        event.preventDefault();
        event.stopPropagation();
        var autocompleteSuggestions = this.model.get('autocompleteSuggestions');
        var index = this.$el.find(event.currentTarget).data('index');
        var relatedIndex = this.$el.find(event.currentTarget).data('related-index');
        var selectedLocation = autocompleteSuggestions[index];
        if (Odigeo._.isNumber(relatedIndex)) {
            selectedLocation = selectedLocation.relatedLocations[relatedIndex];
        }
        this.model.set('selectedLocation', selectedLocation);
        this.skipInputBlur = true;
        this.$el.find(this.selectors.input).trigger('blur');
        this.trigger('fulfilled');
    },

    onKeyPress: function(event) {
        var keyCode = event.keyCode || event.which;
        var navigationKeys = [
            Odigeo.Events.keys.KEY_UP,
            Odigeo.Events.keys.KEY_DOWN,
            Odigeo.Events.keys.KEY_RETURN,
        ];
        if (Odigeo._.contains(navigationKeys, keyCode)) {
            this.executeKey(keyCode);
        }
    },

    executeKey: function(keyCode) {
        var keyCodeActions = {};
        keyCodeActions[Odigeo.Events.keys.KEY_RETURN] = Odigeo._.bind(this.onReturnKeyPressed, this);
        keyCodeActions[Odigeo.Events.keys.KEY_UP] = Odigeo._.bind(this.onUpDownKeyPressed, this);
        keyCodeActions[Odigeo.Events.keys.KEY_DOWN] = Odigeo._.bind(this.onUpDownKeyPressed, this);
        keyCodeActions[keyCode](keyCode);
    },

    onReturnKeyPressed: function() {
        var activeSuggestion = this.$el.find('.autocomplete_item.hover');
        this.$el.find(this.selectors.input).trigger('blur');
        if (this.$el.hasClass('open') && activeSuggestion.length > 0) {
            activeSuggestion.trigger('tap');
            this.$el.removeClass('open');
        }
    },

    onUpDownKeyPressed: function(keyCode) {
        var suggestions = this.$el.find('.autocomplete_item');
        var activeSuggestionIndex = this.$el.find('.autocomplete_item.hover').index();
        var newSuggestionIndex;
        if (this.$el.hasClass('open') && suggestions.length > 0) {
            newSuggestionIndex = activeSuggestionIndex + (keyCode === Odigeo.Events.keys.KEY_UP ? (-1) : +1);

            if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
                newSuggestionIndex = Math.max(0, newSuggestionIndex);
            }

            suggestions.eq(activeSuggestionIndex).removeClass('hover');
            suggestions.eq(newSuggestionIndex).addClass('hover');
        }
    },

    isEmptyOrHasError: function() {
        return !this.model.get('selectedLocation') || this.$airportContainer.hasClass(getErrorClass());
    },

    setFocus: function() {
        this.onInputFocus();
    },
});
